import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import translation from './i18n/en-us/translation.json';

// eslint-disable-next-line import/prefer-default-export
export const resources = {
  en: {
    ...translation,
  },
} as const;

/*
 * Bootstrap the i18n React Hook with translations.
 */
// eslint-disable-next-line @typescript-eslint/no-floating-promises
i18n.use(initReactI18next).init({
  lng: 'en',
  resources,
  interpolation: {
    format: interpolateFormat,
    escapeValue: false,
  },
});

export function interpolateFormat(value: string, format: string | undefined): string {
  if (format === 'capitalize') {
    return value.charAt(0).toUpperCase() + value.slice(1);
  }

  if (format !== undefined) {
    // eslint-disable-next-line no-console
    console.warn('Unknown format', format);
  }
  return value;
}
